<template>
  <div class="summary-accordion-container">
    <!-- {{ rowItems }} -->
    <div class="columns">
      <div
        v-for="(column, index) in columns"
        :key="index"
        class="label"
        :style="{ width: column.width, textAlign: column.textAlign }"
      >
        <span>{{ column.label }}</span>
      </div>
    </div>

    <div v-if="rowItems.length">
      <div
        v-for="(item, index) in rowItems"
        :key="index"
        class="item-container"
      >
        <div class="main-product">
          <div class="column image" :style="{ width: columns[0].width }">
            <img :src="getImage(item)" />
          </div>
          <div class="column product-name" :style="{ width: columns[1].width }">
            <p class="name">
              {{ item.productName | capitalize }}
            </p>
            <img
              v-if="
                item &&
                  item.orderedProductVariants &&
                  item.orderedProductVariants.length > 1
              "
              src="@/assets/dropdownarrow.svg"
              class="arrow"
              :class="{
                active: item.isAccordionActive
              }"
              @click="revealVariants(item.id)"
            />
          </div>
          <div class="column" :style="{ width: columns[2].width }">
            <p class="redeemed" :style="{ textAlign: columns[2].textAlign }">
              {{
                item.type == 'bundles'
                  ? item.redemeedQty
                  : redeemed(item.orderedProductVariants)
              }}
            </p>
          </div>
        </div>
        <div
          v-for="(variant, i) in item.orderedProductVariants"
          :key="i"
          class="variant-list"
          :class="{
            active: item.isAccordionActive
          }"
        >
          <!-- Products Display here -->
          <template v-if="item.type === 'products'">
            <div class="column" :style="{ width: columns[0].width }"></div>
            <div
              class="column variant-name"
              :style="{ width: columns[1].width }"
            >
              <p>{{ variant.name | capitalize }}</p>
            </div>
            <div class="column " :style="{ width: columns[2].width }">
              <p
                class="variant-redeemed"
                :style="{ textAlign: columns[2].textAlign }"
              >
                {{ variant.orderedQuantity }}
              </p>
            </div>
          </template>

          <!-- Bundle Display here -->
          <template v-if="item.type === 'bundles'">
            <div class="column" :style="{ width: columns[0].width }"></div>

            <!-- Variant List here -->
            <div
              class="column variant-name bundle"
              :style="{ width: columns[1].width }"
              :class="{
                'no-border': i === item.orderedProductVariants.length - 1
              }"
            >
              <!-- Product Here  -->
              <div class="product-holder">
                <p>{{ variant.name | capitalize }}</p>
                <span>{{ redeemed(variant.orderedProductVariants) }}</span>
              </div>

              <!-- Ordered Variants here -->
              <div
                class="bundle-items"
                v-for="(ordered, o) in variant.orderedProductVariants"
                :key="o"
              >
                <div
                  class="product-holder"
                  v-bind:style="[
                    o === variant.orderedProductVariants.length - 1
                      ? { 'padding-bottom': '0.375rem' }
                      : { 'padding-bottom': '0.75rem' }
                  ]"
                >
                  <p class="variant">{{ ordered.name | capitalize }}</p>
                  <span>{{ ordered.orderedQuantity }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="no-products" v-if="!rowItems.length">
      <p>There are no items to display.</p>
    </div>
  </div>
</template>

<script>
import { defaultNotFoundImage } from '../../helpers'

export default {
  name: 'SummaryAccordion',
  props: {
    columns: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    },
    rowItems: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },

  methods: {
    revealVariants(productId) {
      let index = this.rowItems.findIndex(row => row.id === productId)
      this.rowItems[index].isAccordionActive = !this.rowItems[index]
        .isAccordionActive
    },
    redeemed(variants) {
      let orderedQuantity = 0

      for (let index = 0; index < variants.length; index++) {
        const variant = variants[index]
        orderedQuantity = orderedQuantity + variant.orderedQuantity
      }
      return orderedQuantity
    },
    redeemedBundles(variants) {
      let orderedQuantity = 0

      for (let index = 0; index < variants.length; index++) {
        const variant = variants[index]
        orderedQuantity = this.redeemed(variant.orderedProductVariants)
      }
      return orderedQuantity
    },
    getImage(item) {
      if (item.orderedProductVariants.length === 0) {
        return defaultNotFoundImage
      } else {
        const itemCheck =
          item.orderedProductVariants &&
          item.orderedProductVariants[0] &&
          item.orderedProductVariants[0]
        if (item.type === 'products') {
          return itemCheck.images.length
            ? item.orderedProductVariants[0].images[0].url
            : defaultNotFoundImage
        }

        return itemCheck.orderedProductVariants &&
          item.orderedProductVariants[0].orderedProductVariants[0] &&
          item.orderedProductVariants[0].orderedProductVariants[0].images.length
          ? item.orderedProductVariants[0].orderedProductVariants[0].images[0]
              .url
          : defaultNotFoundImage
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
.no-products {
  background-color: #f0f0f0;
  padding: 30px;
  text-align: center;
  color: #24292c;
  p {
    font-size: 14px;
  }
}

.summary-accordion-container {
  margin: 0 auto;
  width: 85%;

  .columns {
    display: flex;
    gap: 1.5rem;
    margin: 0.3rem 0;
    /* padding: 0 42px; */
  }

  .label {
    padding: 0.8rem;
    font-size: $content-font-size;
    line-height: 16.37px;
    font-weight: 700;
  }

  .image {
    text-align: right;
  }

  .item-container {
    margin-bottom: 1.125rem;
    color: $main-6;

    .main-product {
      display: flex;
      background: $dark-gray;
      display: flex;
      align-items: center;
      gap: 2rem;
      /* padding: 0 42px; */

      .column {
        padding: 1rem 0.8rem;
      }

      & img {
        width: 41px;
        object-fit: cover;
      }

      .product-name {
        text-align: left;
        display: flex;
        align-items: center;
        gap: 1rem;

        .name {
          font-size: $content-font-size;
        }

        .arrow {
          width: 9px;
          cursor: pointer;
          transition: transform 0.8s ease;
        }

        .arrow.active {
          transform: rotateX(180deg);
        }
      }

      .redeemed {
        font-size: $content-font-size;
        text-align: left;
        font-weight: 700;
      }
    }

    .variant-list {
      .column {
        padding: 0 0.8rem 0.8rem 0.8rem;

        &.bundle {
          padding: 0 0.4rem 0.8rem 0.4rem;
        }
      }

      overflow: hidden;
      display: flex;
      background: $dark-gray;
      align-items: center;
      gap: 2rem;
      max-height: 0;
      -webkit-transition: max-height 0.5s ease;
      -moz-transition: max-height 0.5s ease;
      transition: max-height 0.5s ease;

      .variant-name {
        text-align: left;
        display: flex;
        align-items: baseline;

        & p {
          font-size: 0.688rem;
        }

        &.bundle {
          width: 65% !important;
          display: block;
          border-bottom: 1.5px solid $onyx;
          margin-bottom: 0.875rem;

          div.product-holder {
            font-size: 0.75rem;
            padding-bottom: 0.875rem;
            line-height: 1rem;
            display: flex;

            span {
              margin-left: auto;
              width: 9%;
              text-align: center;
            }

            .variant {
              margin-left: 1.25rem;
            }
          }

          &.no-border {
            border-bottom: none;
          }
        }
      }

      .variant-redeemed {
        font-size: $content-font-size;
        text-align: left;
      }
    }

    .variant-list.active {
      max-height: 100vh;
      transition: max-height 1.5s ease-in-out;
    }
  }

  .empty-state {
    display: flex;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4.813rem;
    background: $main-2;
    color: $main-6;
    font-size: 0.875rem;
  }
}

@media (max-width: 860px) {
  .summary-accordion-container {
    width: 100%;
  }
}
</style>
